export default "__VITE_PUBLIC_ASSET__70094e3e__"